import { Alert, Flex, Modal, Radio, Typography } from "antd"
import { useState } from "react"
import { useTranslation } from "react-i18next"

import type { AlbumDeleteFilesMode } from "../../../../../../Album/types/album.types.ts"

const { Text } = Typography

interface DeleteAlbumModalProps {
  albumName?: string | null
  fileCount?: number
  isDeleting?: boolean
  onClose: () => void
  onConfirm: (files: AlbumDeleteFilesMode) => void
}

export function DeleteAlbumModal({
  albumName,
  fileCount = 0,
  isDeleting,
  onClose,
  onConfirm
}: DeleteAlbumModalProps) {
  const { t } = useTranslation()
  const [files, setFiles] = useState<AlbumDeleteFilesMode>("keep")

  return (
    <Modal
      open
      centered
      title={t("albumDelete.title", { name: albumName ?? "" })}
      okText={t("albumDelete.confirm")}
      cancelText={t("albumDelete.cancel")}
      okButtonProps={{ danger: true }}
      confirmLoading={isDeleting}
      onOk={() => onConfirm(files)}
      onCancel={onClose}
    >
      <Flex vertical gap={"middle"}>
        {fileCount > 0 && (
          <Text type={"secondary"}>
            {t("albumDelete.contains", { count: fileCount })}
          </Text>
        )}

        <Text>{t("albumDelete.question")}</Text>

        <Radio.Group
          value={files}
          onChange={(event) => setFiles(event.target.value)}
        >
          <Flex vertical gap={"small"}>
            <Radio value={"keep"}>{t("albumDelete.options.keep")}</Radio>
            {/* `trash` is offered once there is somewhere to restore from. */}
            <Radio value={"purge"}>{t("albumDelete.options.purge")}</Radio>
          </Flex>
        </Radio.Group>

        {files === "purge" && (
          <Alert
            type={"error"}
            showIcon
            message={t("albumDelete.options.purgeWarning")}
          />
        )}
      </Flex>
    </Modal>
  )
}
